import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../services/ApiClient';
import { ApiEndpoints } from '../../../constants/api-constants';
import { Queries, QueryCacheConfig } from '../../../constants/query-constants';
import { type TargetVessel } from '../../../types';
import { buildSearchFilter } from '../utils/search-utils';
import { type SearchResults, type TripSearchResultViewModel } from '../types';

export const useTripsAndJobsSearchQuery = (
  searchPhrase: string,
  canSearch: boolean,
  operation: string,
  targetVessel: TargetVessel
): SearchResults<TripSearchResultViewModel> => {
  const getResults = async (): Promise<TripSearchResultViewModel[]> => {
    const searchFilter = buildSearchFilter(searchPhrase, operation, targetVessel?.mmsi);
    return apiClient.get<TripSearchResultViewModel[]>(ApiEndpoints.search.getTripsOrJobs(searchFilter));
  };

  const { data, isLoading } = useQuery({
    ...QueryCacheConfig[Queries.SearchTripOrJob],
    queryKey: [Queries.SearchTripOrJob, searchPhrase, operation, targetVessel?.mmsi],
    queryFn: getResults,
    enabled: canSearch,
  });

  return {
    isLoading,
    data,
  };
};
